/** Same budget as the other single-line activity labels. */
export const CAPTURE_LABEL_MAX = 60;
